<template>
  <div>
    <vxe-card>
      <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
    </vxe-card>
    <pack-table ref="packs" :data-sources="dataSources" :limit-types="limitTypes" :shapes="shapes"/>
    <lot-table ref="lots"/>
    <location-limit-table ref="locLimits" :limit-types="limitTypes"/>
    <inventory-limit-table ref="invLimits"/>
  </div>
</template>

<script>
import PackTable from '@/views/basedata/item/PackTable.vue'
import LocationLimitTable from '@/views/basedata/item/LocationLimitTable.vue'
import InventoryLimitTable from '@/views/basedata/item/InventoryLimitTable.vue'
import LotTable from '@/views/basedata/item/LotTable.vue'

export default {
  name: 'ItemExtra',
  components: { InventoryLimitTable, LocationLimitTable, LotTable, PackTable },
  props: {
    dataSources: { type: Array, default: [] },
    limitTypes: { type: Array, default: [] },
    shapes: { type: Array, default: [] }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    refresh(item) {
      this.$refs.packs.refresh(item)
      this.$refs.lots.refresh(item)
      this.$refs.locLimits.refresh(item)
      this.$refs.invLimits.refresh(item)
    }
  }
}
</script>